import React, { Component } from 'react';
import session from '../../utils/session';
import { FilePond } from 'react-filepond';

class ConvertDocQueryV2 extends Component {
    constructor(props){
        super(props);

        this.onRemoveExtractFile = this.onRemoveExtractFile.bind(this);
        this.onExtractProcessed = this.onExtractProcessed.bind(this);
        this.onExtractError = this.onExtractError.bind(this);
        this.onProcess = this.onProcess.bind(this);

        this.state = {
            error: null,
            response: null
        };
    }

    onRemoveExtractFile() {
        this.setState({
            response: null,
            error: null
        })
    }

    onExtractProcessed(data) {   
        this.setState({
            response: data,
            error: null
        });
    }

    onExtractError(data) {
        this.setState({
            response: null,
            error: data
        }, () => {
            console.log('Extract Error => ', data);
        }); 
    }

    onProcess() {
        console.log('onProcess Here');
    }

    render() {
        return (
            <div>
                <div className="deprecated">
                    <span className="fa fa-exclamation-triangle">&nbsp;</span>
                    The below demo has a timeout and requests that take too long will result in failure to extract. Simple documents are recommended.
                </div>
                <div className="note">
                    <span className="fa fa-info-circle">&nbsp;</span>
                    When using the api there are no default timeouts and larger and more complex documents can be used.
                </div>
                <div style={{maxWidth: '400px'}}>
                    <FilePond ref={(ref) => {this.pond = ref}}
                        onremovefile={() => this.onRemoveExtractFile() }
                        server={{
                            url: './../extract2',
                            timeout: 130000,
                            process: {
                                onload: (data) => {this.onExtractProcessed(data)},
                                onerror: (data) => {this.onExtractError(data)},
                                headers: {
                                    'X-Finch': 'Bearer ' + session.getToken()
                                }
                            },
                            restore: null,
                            revert: null,
                            load: null,
                            fetch: null
                        }}
                        name="extractfile"
                        labelIdle={'<span class="filepond--label-action\">Select file</span>'}
                        labelFileProcessing={'Extracting text'}
                        labelFileProcessingComplete={'Extraction complete'}
                        labelFileProcessingError={'Error during extraction'}
                        labelFileProcessingAborted={'Extraction cancelled'}>
                    </FilePond>
                    <span style={{color:'indianRed', fontSize: '14px'}}>{this.state.error}</span>
                </div>
                {(session.isAuthenticated() && this.state.response) &&
                <div className='example-query-wrapper'>
                    <div>Extracted Text:</div>
                    <div className='example-query-response'>
                        <code id='text'>
                            <pre>{this.state.response}</pre>
                        </code>
                    </div>
                </div>
                }
            </div>
        );
    }

}

export default ConvertDocQueryV2;